import { render, staticRenderFns } from "./TwoAuthenticator.vue?vue&type=template&id=b5f994fe"
import script from "./TwoAuthenticator.vue?vue&type=script&lang=ts"
export * from "./TwoAuthenticator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports